<div class="grid grid-cols-1 lg:grid-cols-2">

    <div>
        <span class="text-[20px] font-bold w-[348px] text-[rgba(30,72,84,1)] order-0" >
           <a class="text-[rgba(30,72,84,1)]" href="/auction/{{this.auction!.auctionId}}" >
           {{this.auction?.auctionName}}
        </a> 
        </span>
    </div>
    <div class="row-span-3 lg:pl-[30px] lg:mt-[38px] mt-[20px] lg:order-1 order-2">
        <div class="grid lg:grid-cols-3 grid-cols-4 ">
            <div class="lg:col-span-2 col-span-3">
                <div>
                    <span class="text-[rgba(27,31,35,1)] lg:text-[12px] text-[14px] whitespace-nowrap">{{this.auction?.onlineOpenDate | date:'MMM dd, yyyy hh:mm a'}}</span><span class="pl-[5px] text-[rgba(0,106,152,1)] lg:text-[12px] text-[14px] font-bold lg:font-semibold">Open</span>
                </div>
                <div class="lg:mt-[18px] mt-[10px]">
                    <span class="text-[rgba(27,31,35,1)] lg:text-[12px] text-[14px] whitespace-nowrap">{{this.auction?.onlineCloseDate | date:'MMM dd, yyyy hh:mm a'}}</span><span class="pl-[5px] text-[rgba(0,106,152,1)] lg:text-[12px] text-[14px] font-bold lg:font-semibold">Close</span>
                </div>
                <div class="lg:mt-[18px] mt-[10px]">
                    <span class="text-[rgba(27,31,35,1)] lg:text-[12px] text-[14px] whitespace-nowrap">{{this.auction?.liveEventOpenDate | date:'MMM dd, yyyy hh:mm a'}}</span><span class="pl-[5px] text-[rgba(0,106,152,1)] lg:text-[12px] text-[14px] font-bold lg:font-semibold whitespace-nowrap">Live Event</span>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="lg:mt-[12px]">
                    <div class="flex flex-row-reverse">
                        <fa-icon (click)="onDelete(this.auction!)" [icon]="faTrashCan" class="text-[25px] text-[rgba(110,110,110,1)]"></fa-icon>
                    </div>
                </div>
                <div class="lg:flex hidden flex-row-reverse">
                    <span class="text-[rgba(27,31,35,1)] text-[14px]">{{getTimeLeftUntilAuctionOnlineCloseDate(this.auction!)}}</span>  
                </div>
            </div>
        </div>
       
    </div>
    <div class="lg:mt-[18px] mt-[7px] lg:order-2 order-1">
        <span class="text-[rgba(27,31,35,1)] text-[18px]">{{this.auction?.orgName}}</span>
    </div>
    <div class="lg:pt-[15px] pt-[30px] pb-[12px] order-3 grid grid-cols-3 lg:grid-cols-1 ">
        <div class="col-span-2 lg:col-span-1">
            <span class="text-[rgba(27,31,35,1)] text-[14px]">{{this.auction?.orgCity}}, {{this.auction?.orgRegion}}</span><span class="pl-[5px] text-[rgba(0,106,152,1)] text-[12px] lg:inline hidden font-semibold">Location</span>
        </div>
        <div class="lg:hidden flex flex-row-reverse">
            <span class="text-[rgba(27,31,35,1)] text-[14px]">{{getTimeLeftUntilAuctionOnlineCloseDate(this.auction!)}} left</span>  
        </div>
    </div>

</div>


<div class="lg:mt-[12px] h-[1px] w-full bg-[rgba(223,231,239,1)]"></div>
